/* Afterlights — photoreal label wrap engine
   Maps a flat label texture onto the front arc of a cylinder (no back half, no
   rotation) and composites it onto a fixed studio candle photo, with shading,
   a matte specular band, contact shadow and tone-match. Pure canvas, realtime.

   WrapEngine.loadBase(src, baseCanvas, cb)  — load + paint the studio photo
   WrapEngine.render(baseCanvas, wrapCanvas, labelCanvas, settings)
   settings = { rx0,rx1,ry0,ry1 (% of photo), capT,capB (px@working res),
                arc (deg), depth(0-100), shade,hix,hiw,his,contact,warm (0-100) } */
(function(){
  /* phones / low-memory devices get a lighter budget — full-size canvases × several scenes crashed iOS Safari */
  var IOS = (function(){ try{ return /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform==='MacIntel' && navigator.maxTouchPoints>1); }catch(e){ return false; } })();
  var LOW = (function(){ try{ return IOS || (navigator.deviceMemory&&navigator.deviceMemory<=4) || Math.min(screen.width,screen.height)<=820; }catch(e){ return false; } })();
  var MAXW = LOW ? 1000 : 1500;   // working resolution cap
  var SS = LOW ? 1.25 : 2;        // supersampling for the label region
  var baseImg = null, baseRatio = 1;
  /* ask Shopify's CDN for a photo at working size — a 4000px original decodes to ~80 MB, this to ~6–12 MB.
     Clamp rather than bail out when the caller already set a width: every photo URL the PDP and the
     gallery build goes through `image_url: width: 1600`, so an early return here meant the phone cap
     was never applied anywhere on the page and each base photo decoded at 1600 (10.2 MB) instead of
     1000 (4.0 MB). loadBase() draws into a canvas of min(MAXW, naturalWidth) either way, so those
     extra pixels were decoded and thrown away — clamping costs nothing visually. */
  function sized(src){
    try{
      if(!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return src;
      var u=new URL(src, location.href);
      var w=parseInt(u.searchParams.get('width'),10);
      if(w>0 && w<=MAXW) return src;              /* already at or under the cap */
      u.searchParams.set('width', String(MAXW));  /* only ever narrows */
      return u.toString();
    }catch(e){ return src; }
  }
  /* decoded photos are shared by every preview that uses the same mockup (max 3 kept) */
  var IMG_CACHE = [];
  function getImg(src, cb){
    for(var i=0;i<IMG_CACHE.length;i++){ if(IMG_CACHE[i].src===src){ var hit=IMG_CACHE[i]; if(hit.img) { cb(null, hit.img); } else hit.wait.push(cb); return; } }
    var rec={src:src, img:null, wait:[cb]}; IMG_CACHE.push(rec); if(IMG_CACHE.length>3) IMG_CACHE.shift();
    var img = new Image(); img.crossOrigin='anonymous'; img.decoding='async';
    img.onload=function(){ rec.img=img; var w=rec.wait; rec.wait=[]; w.forEach(function(f){ f(null,img); }); };
    img.onerror=function(){ var k=IMG_CACHE.indexOf(rec); if(k>=0) IMG_CACHE.splice(k,1); var w=rec.wait; rec.wait=[]; w.forEach(function(f){ f(new Error('base load')); }); };
    img.src=sized(src);
  }

  function loadBase(src, baseCanvas, cb){
    getImg(src, function(err, img){
      if(err){ cb && cb(err); return; }
      baseImg = img; baseRatio = img.naturalHeight/img.naturalWidth;
      var W = Math.min(MAXW, img.naturalWidth), H = Math.round(W*baseRatio);
      baseCanvas.width=W; baseCanvas.height=H;
      var bx=baseCanvas.getContext('2d'); bx.imageSmoothingEnabled=true; bx.imageSmoothingQuality='high'; bx.drawImage(img,0,0,W,H);
      cb && cb();
    });
  }

  function clamp(v,a,b){ v=+v; if(isNaN(v)) v=a; return v<a?a:(v>b?b:v); }
  function mix(a,b,t){ return a+(b-a)*t; }

  function render(baseCanvas, wrapCanvas, label, S){
    if(!baseImg) return;
    var W = baseCanvas.width, H = baseCanvas.height;
    if(wrapCanvas.width!==W){ wrapCanvas.width=W; wrapCanvas.height=H; }
    var ctx = wrapCanvas.getContext('2d');
    ctx.clearRect(0,0,W,H);

    // region in working px
    var x0=S.rx0/100*W, x1=S.rx1/100*W, y0=S.ry0/100*H, y1=S.ry1/100*H;
    var RW=Math.max(2,Math.round(x1-x0)), RH=Math.max(2,Math.round(y1-y0));
    var capT=(S.capT||0)/100*RW, capB=(S.capB||0)/100*RW;   // cap is % of region width (capT may be negative = bow up)
    var lightDir=clamp(S.lightDir==null?0:S.lightDir,-100,100)/100;   // -1 light from left .. +1 from right

    var arc = clamp(S.arc,10,178)*Math.PI/180;
    var halfA = arc/2, sinHalf = Math.sin(halfA);
    var depth = clamp(S.depth,0,100)/100;
    var edgeShade = clamp(S.shade,0,100)/100;

    // offscreen region canvas — pad vertically so negative caps (bow up) aren't clipped
    var PAD=Math.ceil(Math.max(Math.abs(capT),Math.abs(capB))+2);
    // destination size (working px) vs. supersampled drawing size
    var dRW=RW, dRH=RH, dPAD=PAD;
    var ss=S.fast?1:SS;                 // fast = interactive drag preview (Lab): no supersampling
    RW*=ss; RH*=ss; PAD*=ss; capT*=ss; capB*=ss;
    var rc = render._rc || (render._rc=document.createElement('canvas'));
    rc.width=RW; rc.height=RH+PAD*2;
    var r = rc.getContext('2d');
    r.clearRect(0,0,RW,RH+PAD*2);
    r.imageSmoothingEnabled=true; r.imageSmoothingQuality='high';

    // pre-scale the label texture close to the drawn width with stepwise halving —
    // sampling 1px columns from a much larger source aliases text and fine symbol lines
    var tex=label;
    if(label.width>RW*1.6){
      var cw=label.width, ch=label.height, cur=label;
      while(cw/2>=RW){
        cw=Math.round(cw/2); ch=Math.round(ch/2);
        var tc=document.createElement('canvas'); tc.width=cw; tc.height=ch;
        var tx=tc.getContext('2d'); tx.imageSmoothingEnabled=true; tx.imageSmoothingQuality='high';
        tx.drawImage(cur,0,0,cw,ch); cur=tc;
      }
      tex=cur;
    }
    // a whisper of softness so type and symbols read as printed ink, not screen pixels
    var soft=S.fast?0:(S.soft==null?0.55:+S.soft);
    var bright=(S.bright==null||isNaN(+S.bright))?100:clamp(+S.bright,40,160); // label paper/ink brightness, % (100 = as designed)
    if(soft>0||bright!==100){
      var sf=render._sf || (render._sf=document.createElement('canvas'));
      sf.width=tex.width; sf.height=tex.height;
      var sx=sf.getContext('2d');
      if('filter' in sx){
        sx.clearRect(0,0,sf.width,sf.height);
        sx.filter=(soft>0?'blur('+soft.toFixed(2)+'px) ':'')+(bright!==100?'brightness('+(bright/100).toFixed(3)+')':'');
        sx.drawImage(tex,0,0);
        sx.filter='none';
        tex=sf;
      }
    }
    var lw = tex.width, lh = tex.height;

    // ---- 1. cylindrical column mapping (front arc only) ----
    var shadeW=clamp(S.shadeW==null?0:+S.shadeW,0,100)/100, maxFall=1-Math.cos(halfA);
    // shadow temperature: -1 cool (blue-grey) .. 0 neutral-warm (original) .. +1 warm (amber-brown)
    var stp=clamp(S.stemp==null?0:+S.stemp,-100,100)/100;
    function shCol(base,warmC,coolC){ var t=Math.abs(stp), o=stp>=0?warmC:coolC; return [Math.round(mix(base[0],o[0],t)),Math.round(mix(base[1],o[1],t)),Math.round(mix(base[2],o[2],t))].join(','); }
    var SH_EDGE=shCol([28,22,15],[46,24,6],[12,18,30]), SH_CONT=shCol([20,15,9],[38,18,4],[8,13,24]);
    // ink layer: same cylinder mapping without shading, used to keep light passes OFF the text/graphics
    var mc=render._mc||(render._mc=document.createElement('canvas')); mc.width=RW; mc.height=RH+PAD*2;
    var mx=mc.getContext('2d'); mx.clearRect(0,0,mc.width,mc.height);
    for(var jx=0; jx<RW; jx++){
      var p = RW>1 ? jx/(RW-1) : 0.5;     // 0..1 across the visible arc
      var pc = p*2-1;                      // -1..1 (screen position, linear)
      var phi = Math.asin(clamp(pc*sinHalf,-1,1));   // angle on cylinder
      var texCurved = (phi/halfA+1)/2;     // texture coord if fully wrapped
      var texU = mix(p, texCurved, depth); // blend flat<->curved by depth
      var srcX = clamp(texU*(lw-1),0,lw-1);

      // vertical cap: sides of the label ride up/down as the surface turns away
      var edge = pc*pc;                    // 0 center -> 1 edges
      var top = PAD + capT*edge, bot = capB*edge;
      var colH = RH - capT*edge - bot;
      if(colH<=0) continue;

      r.drawImage(tex, srcX,0,1,lh, jx,top,1,colH);
      mx.drawImage(tex, srcX,0,1,lh, jx,top,1,colH);

      // edge shading baked per-column (multiply dark toward the turning edges),
      // biased by light direction so the side facing away from the light is darker
      var sd = lightDir*(-pc);              // >0 on the shadow side, <0 on the lit side
      var bias = sd>=0 ? 1+sd*1.3 : Math.max(0,1+sd*2.6);  // lit side clears quickly → clearly one-sided
      var fall = 1-Math.cos(phi);
      if(shadeW>0.001 && maxFall>1e-6){ fall = Math.pow(fall/maxFall, 1-shadeW*0.85)*maxFall; } // wider = shadow reaches further toward the centre
      var dark = fall*edgeShade*Math.max(0,bias);
      if(dark>0.001){
        r.globalCompositeOperation='source-atop';
        r.fillStyle='rgba('+SH_EDGE+','+clamp(dark,0,0.95).toFixed(4)+')';
        r.fillRect(jx,top,1,colH);
        r.globalCompositeOperation='source-over';
      }
    }

    // keep the label's own silhouette so the blend-mode passes below can't
    // spill onto the transparent padding/cap area (that showed as a hard box)
    var sc = render._sc || (render._sc=document.createElement('canvas'));
    sc.width=RW; sc.height=RH+PAD*2;
    var s2=sc.getContext('2d'); s2.clearRect(0,0,RW,RH+PAD*2); s2.drawImage(rc,0,0);

    // ---- 3. tone-match / warmth (kills pure-white, inherits studio light) ----
    var warm=clamp(S.warm,0,100)/100;
    if(warm>0.001){
      r.globalCompositeOperation='multiply';
      r.fillStyle='rgba(243,233,214,'+(warm*0.7).toFixed(3)+')';
      r.fillRect(0,0,RW,RH+PAD*2);
      r.globalCompositeOperation='source-over';
    }

    // ---- 3b. label tint: pick a hue + strength to match coloured light / colour grading ----
    var tamt=clamp(S.tamt==null?0:+S.tamt,0,100)/100;
    if(tamt>0.001){
      var th=((+S.thue||0)%360+360)%360;
      r.globalCompositeOperation='multiply';
      r.fillStyle='hsla('+th.toFixed(0)+',55%,72%,'+(tamt*0.75).toFixed(3)+')';
      r.fillRect(0,0,RW,RH+PAD*2);
      r.globalCompositeOperation='source-over';
    }

    // build the ink mask once: dark pixels (text, symbols, footer) → opaque; paper → transparent
    var inkM=render._im||(render._im=document.createElement('canvas')); inkM.width=mc.width; inkM.height=mc.height; // resizing clears it
    if(!S.fast) (function(){
      var d=mx.getImageData(0,0,mc.width,mc.height), px=d.data;
      /* paper tone = most common luminance of the opaque pixels, so dark (Christmas) labels keep their highlight:
         "ink" is whatever contrasts with the paper, not simply whatever is dark */
      var hist=new Uint32Array(32), n=0;
      for(var j=0;j<px.length;j+=64){ if(px[j+3]<128) continue; hist[Math.min(31,((px[j]*0.299+px[j+1]*0.587+px[j+2]*0.114)/8)|0)]++; n++; }
      var pk=31; if(n){ var best=-1; for(var q=0;q<32;q++){ if(hist[q]>best){ best=hist[q]; pk=q; } } }
      var Lp=(pk+0.5)/32;
      for(var i=0;i<px.length;i+=4){
        var L=(px[i]*0.299+px[i+1]*0.587+px[i+2]*0.114)/255, a=px[i+3]/255;
        var ink=Math.max(0,Math.min(1,(Math.abs(L-Lp)-0.14)/0.36))*a;   // paper → 0, anything that contrasts with it → 1
        px[i]=px[i+1]=px[i+2]=0; px[i+3]=Math.round(ink*255);
      }
      inkM.getContext('2d').putImageData(d,0,0);
    })();
    var hlc=render._hl||(render._hl=document.createElement('canvas'));
    function paintLight(grad, mode){
      hlc.width=mc.width; hlc.height=mc.height;
      var hx=hlc.getContext('2d'); hx.clearRect(0,0,hlc.width,hlc.height);
      hx.fillStyle=grad; hx.fillRect(0,0,hlc.width,hlc.height);
      hx.globalCompositeOperation='destination-out'; hx.drawImage(inkM,0,0); hx.globalCompositeOperation='source-over';
      r.globalCompositeOperation=mode; r.drawImage(hlc,0,0); r.globalCompositeOperation='source-over';
    }

    // ---- 2. matte specular band ----
    var his=clamp(S.his,0,100)/100;
    if(his>0.001){
      var hx=clamp(S.hix,0,100)/100*RW, hw=Math.max(2,clamp(S.hiw,1,100)/100*RW);
      var g=r.createLinearGradient(hx-hw,0,hx+hw,0);
      g.addColorStop(0,'rgba(255,251,243,0)');
      g.addColorStop(0.5,'rgba(255,251,243,'+(his*0.6).toFixed(3)+')');
      g.addColorStop(1,'rgba(255,251,243,0)');
      paintLight(g,'soft-light');   // matte, not glossy — paper only, ink stays on top
    }
    // ---- 2b. highlight exposure: a 'screen' pass on the same band — brightens past the label's own
    //      brightness (sits above it in the stack), like real light blooming on the paper ----
    var hexp=clamp(S.hexp==null?0:+S.hexp,0,100)/100;
    if(hexp>0.001){
      var hx2=clamp(S.hix,0,100)/100*RW, hw2=Math.max(2,clamp(S.hiw,1,100)/100*RW);
      var g2=r.createLinearGradient(hx2-hw2,0,hx2+hw2,0);
      g2.addColorStop(0,'rgba(255,250,240,0)');
      g2.addColorStop(0.5,'rgba(255,250,240,'+(hexp*0.85).toFixed(3)+')');
      g2.addColorStop(1,'rgba(255,250,240,0)');
      paintLight(g2,'screen');      // exposure — paper only, ink stays on top
    }

    // ---- 4. contact shadow where label meets glass (inner edges), light-biased ----
    var contact=clamp(S.contact,0,100)/100;
    if(contact>0.001){
      var cw=Math.max(3,RW*0.06);
      function sideF(v){ return v>=0 ? 1+v*1.3 : Math.max(0,1+v*2.6); }
      var lA=contact*0.55*sideF(lightDir);    // left edge: darker when lit from right
      var rA=contact*0.55*sideF(-lightDir);   // right edge: darker when lit from left
      r.globalCompositeOperation='source-atop';
      var gl=r.createLinearGradient(0,0,cw,0);
      gl.addColorStop(0,'rgba('+SH_CONT+','+clamp(lA,0,0.9).toFixed(3)+')');
      gl.addColorStop(1,'rgba('+SH_CONT+',0)');
      r.fillStyle=gl; r.fillRect(0,0,cw,RH+PAD*2);
      var gr=r.createLinearGradient(RW,0,RW-cw,0);
      gr.addColorStop(0,'rgba('+SH_CONT+','+clamp(rA,0,0.9).toFixed(3)+')');
      gr.addColorStop(1,'rgba('+SH_CONT+',0)');
      r.fillStyle=gr; r.fillRect(RW-cw,0,cw,RH+PAD*2);
      r.globalCompositeOperation='source-over';
    }

    // ---- clip every effect back to the label shape ----
    r.globalCompositeOperation='destination-in';
    r.drawImage(sc,0,0);
    r.globalCompositeOperation='source-over';

    // ---- composite region onto the overlay canvas (offset by PAD) ----
    // ---- perspective: taper (top wider/narrower than bottom) + rotation ----
    var src=rc, dW=dRW, taper=clamp(+S.taper||0,-60,60)/100, rot=clamp(+S.rot||0,-45,45)*Math.PI/180;
    if(Math.abs(taper)>0.001){
      var extra=Math.abs(taper)/2, tw=Math.ceil(rc.width*(1+extra)), th=rc.height;
      var tc=render._tc||(render._tc=document.createElement('canvas'));
      tc.width=tw; tc.height=th;
      var tx=tc.getContext('2d'); tx.clearRect(0,0,tw,th); tx.imageSmoothingEnabled=true; tx.imageSmoothingQuality='high';
      for(var yy=0; yy<th; yy++){
        var k=1+taper*(0.5-yy/Math.max(1,th-1));       // taper>0 → top wider (camera looking down)
        var w2=rc.width*k;
        tx.drawImage(rc,0,yy,rc.width,1,(tw-w2)/2,yy,w2,1);
      }
      src=tc; dW=dRW*(tw/rc.width);
    }
    ctx.imageSmoothingEnabled=true; ctx.imageSmoothingQuality='high';
    var ccx=x0+dRW/2, ccy=y0+dRH/2;
    ctx.save(); ctx.translate(ccx,ccy); if(rot) ctx.rotate(rot);
    ctx.drawImage(src, 0,0,src.width,src.height, -dW/2, -(dRH/2+dPAD), dW, dRH+dPAD*2);
    ctx.restore();
  }

  window.WrapEngine = { loadBase:loadBase, render:render, LOW:LOW, MAXW:MAXW };
})();
